import api from "lib/api";

export const getBranchList = async (params = {}) => {
  return await api.post("/v1/branch/getBranchPaging", params);
};

export const getBranch = async (params = {}) => {
  return await api.post("/v1/branch/getBranch", params);
};

export const createBranch = async (params = {}) => {
  return await api.post("/v1/branch/createBranch", params);
};

export const editBranch = async (params = {}) => {
  return await api.post("/v1/branch/updateBranch", params);
};

export const deleteBranch = async (params = {}) => {
  return await api.post("/v1/branch/manageStatusBranch", params);
};
